<template>
  <nna-container>
    <div class="">
      <h1 class="md-title">{{title}}</h1>
      <div class="services_icon mt-4 mb-4">
        <div v-for="s in list" :key="s.name" class="md-list-item-content">
          <i class="services_icon__img md-icon md-icon-font">
            <img :src="s.icon" :name="s.name" />
          </i>
          <span class="services_icon__name md-list-item-text">{{s.name}}</span>
        </div>
      </div>
    </div>
  </nna-container>  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ServicesOffered',
  computed: {
    list() {
      return this.$route.params.page.list ? this.$route.params.page.list : ''
    },
    title() {
      return this.$route.params.page.title ? this.$route.params.page.title : ''
    }    
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/modules/terms/pages/ServicesOffered.vue